"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecurityGroupId = exports.shouldAddKey = exports.shouldIncludeKey = exports.isOauth2ClientCredentialsOrPasswordFlow = exports.isOauth2AuthorizationCodeFlow = exports.isOAuth2ImplicitFlow = exports.getServiceUriFromOperation = exports.getReadableSecurityNames = exports.getReadableSecurityName = void 0;
const hash_1 = require("@stoplight/http-spec/hash");
const lodash_1 = require("lodash");
function getReadableSecurityName(securityScheme, includeKey = false) {
    let name = '';
    switch (securityScheme.type) {
        case 'apiKey':
            name = 'API Key';
            break;
        case 'http':
            name = `${(0, lodash_1.capitalize)(securityScheme.scheme)} Auth`;
            break;
        case 'oauth2':
            name = 'OAuth 2.0';
            break;
        case 'openIdConnect':
            name = 'OpenID Connect';
            break;
        case 'mutualTLS':
            name = 'Mutual TLS';
            break;
        case undefined:
            name = 'None';
            break;
    }
    return includeKey ? `${name} (${securityScheme.key})` : name;
}
exports.getReadableSecurityName = getReadableSecurityName;
function getReadableSecurityNames(securitySchemes, includeKey = false) {
    if (securitySchemes.length === 0)
        return 'None';
    let name = '';
    for (let i = 0; i < securitySchemes.length; i++) {
        if (i > 0)
            name += ' & ';
        name += getReadableSecurityName(securitySchemes[i], shouldIncludeKey(securitySchemes, securitySchemes[i].type));
    }
    return includeKey ? `${name} (${securitySchemes[0].key})` : name;
}
exports.getReadableSecurityNames = getReadableSecurityNames;
function getServiceUriFromOperation(uri) {
    const match = uri === null || uri === void 0 ? void 0 : uri.match(/(.*)\/(paths|operations)/);
    return match && match.length > 1 ? match[1] || '/' : undefined;
}
exports.getServiceUriFromOperation = getServiceUriFromOperation;
const isOAuth2ImplicitFlow = (maybeFlow) => (0, lodash_1.isObject)(maybeFlow) && 'authorizationUrl' in maybeFlow && !('tokenUrl' in maybeFlow);
exports.isOAuth2ImplicitFlow = isOAuth2ImplicitFlow;
const isOauth2AuthorizationCodeFlow = (maybeFlow) => (0, lodash_1.isObject)(maybeFlow) && 'authorizationUrl' in maybeFlow && 'tokenUrl' in maybeFlow;
exports.isOauth2AuthorizationCodeFlow = isOauth2AuthorizationCodeFlow;
const isOauth2ClientCredentialsOrPasswordFlow = (maybeFlow) => (0, lodash_1.isObject)(maybeFlow) && !('authorizationUrl' in maybeFlow) && 'tokenUrl' in maybeFlow;
exports.isOauth2ClientCredentialsOrPasswordFlow = isOauth2ClientCredentialsOrPasswordFlow;
function shouldIncludeKey(schemes, type) {
    return (0, lodash_1.filter)(schemes, { type }).length > 1;
}
exports.shouldIncludeKey = shouldIncludeKey;
const shouldAddKey = (auth, operationSecuritySchemes) => {
    if (auth.length !== 1)
        return false;
    return shouldIncludeKey((0, lodash_1.flatten)(operationSecuritySchemes.filter(scheme => scheme.length === 1)), auth[0].type);
};
exports.shouldAddKey = shouldAddKey;
const getSecurityGroupId = (id, position) => {
    return (0, hash_1.hash)(`http_security_group-${id}-${position}`);
};
exports.getSecurityGroupId = getSecurityGroupId;
//# sourceMappingURL=security.js.map